import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';
import {GeneralClairvoyantComponent} from '../g-clairvoyant.component';

@Component({
  selector: 'app-clairvoyant',
  templateUrl: './clairvoyant.component.html',
  styleUrls: ['./clairvoyant.component.css']
})
export class ClairvoyantComponent extends GeneralClairvoyantComponent {

  solution: number;
  clickedValue: number;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  checkSolution() {
    // if solution correct, generate new exercise
    if (this.clickedValue === this.solution) {
      this.solution = -1;
      this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
      this.isSolvedImageVisible = true;
      setTimeout(() => { this.generateNextExercise(); }, 800);
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  setClickedValue( solutionNumber: number) {
    // check if solution is correct
    this.clickedValue = solutionNumber;
    this.checkSolution();
  }

  setSolution (counterClosedCards: number) {
    this.solution = counterClosedCards;
  }
}
